<template>
  <div v-loading="loading" class="YiXinApplicationPreview">
    <div>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">基本信息</div>
      <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
        <tr>
          <td class="tableLabel">标题:</td>
          <td>{{application.title}}</td>
          <td class="tableLabel">编号:</td>
          <td>{{application.applicationNo}}</td>
          <td class="tableLabel">申请人:</td>
          <td>{{application.creatorName}}</td>
        </tr>
        <tr>
          <td class="tableLabel">申请公司:</td>
          <td>{{application.customerName}}</td>
          <td class="tableLabel">申请日期:</td>
          <td>{{application.createTime}}</td>
          <td class="tableLabel">申请部门:</td>
          <td>{{application.departmentName}}</td>
        </tr>
        <tr>
          <td class="tableLabel">合同单位全称:</td>
          <td>{{application.unitCustomerName}}</td>
          <td class="tableLabel">出厂日期:</td>
          <td>{{application.outFactoryDate}}</td>
          <td class="tableLabel">合同编号:</td>
          <td>{{application.clientContractNo}}</td>
        </tr>
        <tr>
          <td class="tableLabel">客户要求交货期:</td>
          <td>{{application.deliveryDate}}</td>
          <td class="tableLabel">发货金额:</td>
          <td>{{application.shipmenAmount}}</td>
          <td class="tableLabel">新老客户:</td>
          <td>
            <span v-if="application.oldCustomer === true">老客户</span>
            <span v-if="application.oldCustomer === false">新客户</span>
          </td>
        </tr>
        <tr>
          <td class="tableLabel">是否冲销:</td>
          <td>
            <span v-if="application.writeOff === true">是</span>
            <span v-if="application.writeOff === false">否</span>
          </td>
          <td class="tableLabel">冲销对应PC号:</td>
          <td>{{application.writeOffFactoryNos}}</td>
          <td class="tableLabel">是否正式报关:</td>
          <td>
            <span v-if="application.declareCustoms === true">是</span>
            <span v-if="application.declareCustoms === false">否</span>
          </td>
        </tr>
        <tr>
          <td class="tableLabel">报关金额:</td>
          <td>{{application.declareCustomsAmount}}</td>
          <td class="tableLabel">付款方式:</td>
          <td>{{application.payment}}</td>
          <td class="tableLabel">合同约定运输方式:</td>
          <td>{{application.contractShipmentType}}</td>
        </tr>
        <tr>
          <td class="tableLabel">DHL费用承担方:</td>
          <td>{{application.dHLShipmentBelong}}</td>
          <td class="tableLabel">包装要求:</td>
          <td>{{application.packRequirement}}</td>
          <td class="tableLabel">品类:</td>
          <td>{{application.category}}</td>
        </tr>
        <tr>
          <td class="tableLabel">评审交期:</td>
          <td>{{application.reviewDeadline}}</td>
          <td class="tableLabel">供货公司:</td>
          <td>
            <el-checkbox-group v-model="application.supplyCompanyList" disabled>
              <el-checkbox label="电气"/>
              <el-checkbox label="外购"/>
            </el-checkbox-group>
          </td>
          <td class="tableLabel">订仓日期:</td>
          <td v-if="nodeId='YiXinDocumentApprove'">
            <el-date-picker v-model="application.bookingDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" @change="updateApplication"/>
          </td>
          <td v-else>{{application.bookingDate}}</td>
<!--          <td>{{application.bookingDate}}</td>-->
        </tr>
        <tr>
          <td class="tableLabel">实际收款情况:</td>
          <td>{{application.actualCharges}}</td>
          <td class="tableLabel">币种名称:</td>
          <td>{{application.currencyName}}</td>
          <td class="tableLabel">进仓日期:</td>
          <td> {{application.warehouseDate}}</td>
        </tr>
        <tr>
          <td class="tableLabel">进仓地址:</td>
          <td>{{application.warehouseAddress}}</td>
          <td class="tableLabel">联系人:</td>
          <td>{{application.warehouseContact}}</td>
          <td class="tableLabel">联系电话:</td>
          <td>{{application.warehousePhone}}</td>
        </tr>
        <tr>
          <td class="tableLabel">最终客户</td>
          <td>{{application.finalCustomerName}}</td>
        </tr>
        <tr>
          <td class="tableLabel">出厂编号:</td>
          <td colspan="5" type="textarea">{{application.factoryNos}}</td>
        </tr>
      </table>
    </div>
    <div>
      <div
          style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        发货明细
      </div>
      <div style="color: #2d8cf0; font-size: 12px; margin-left: 1%; cursor: pointer" @click="changeDetailShow()">
        {{isShowDetail ? "隐藏" : "展开"}}
        <el-button style="padding: 1px 2px" :icon="isShowDetail ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"/>
      </div>
      <el-table
          v-if="isShowDetail"
          ref="payData1"
          :data="application.detailList">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="techParamBillNo" align="center" label="出厂编号" width="100"/>
        <el-table-column prop="invoiceNo" align="center" label="发货单" width="100"/>
        <el-table-column prop="salesOrderNo" align="center" label="销售订单" width="100"/>
        <el-table-column prop="materialCode" align="center" label="物料编号" width="250"/>
        <el-table-column prop="materialName" align="center" label="物料名称"/>
        <el-table-column prop="salesOrderQty" align="center" label="销单数量" width="100"/>
        <el-table-column prop="quantity" align="center" label="发货数量" width="150">
          <template slot-scope="scope">
            <el-input-number v-if="scope.row.type === '外采'" v-model="scope.row.quantity" size="mini" @change="setPrice(scope.row)"/>
            <span v-if="scope.row.type === '电气'">{{scope.row.quantity}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="unitPrice" align="center" label="含税单价" width="100"/>
        <el-table-column prop="totalPrice" align="center" label="含税总价" width="100"/>
        <el-table-column prop="type" align="center" label="发货类别" width="100"/>
      </el-table>
    </div>
    <div>
      <div
          style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        订单附件
      </div>
      <el-button
          type="primary"
          style="margin-bottom:5px"
          :loading="downLoadLoading"
          @click="downloadAll">
        下载所有附件
      </el-button>
      <el-table ref="payData1" border :data="application.accessoryList">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="fileName" align="left" label="附件描述" width="750"/>
        <el-table-column label="下载" width="70" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="download(scope.row)">下载</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="note" align="center" label="备注" show-overflow-tooltip/>
      </el-table>
    </div>
    <handle-detail v-if="billId" :bill-id="billId" :bill-type="billType" :sequ-id="'-1'"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "YiXinApplicationPreview",
    components: {HandleDetail},
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        priceAuth: this.$auth(417),
        loading: false,
        downLoadLoading: false,
        flag: true,
        isShowDetail: true,
        isShowPack: true,
        uploadLoading: false,
        nodeId: "",
        application: {},
        yiXinDocumentApprove: false,
      };
    },
    watch: {
      $route: {
        handler: function(val) {
          if (val.name === "YiXinApplicationPreview") {
            this.getData(this.$route.query.billId);
          }
        },
      },
      params: {
        handler() {
          console.log(this.params);
          this.nodeId = this.params.nodeId;
          this.doApprove();
        },
      },
      billId: {
        handler() {
          this.$forceUpdate();
        },
      },
    },

    created() {
      this.getData(this.$route.query.billId);
      this.getNodeValue();
    },
    methods: {
      // 根据销售订单id查询详细信息
      getData(pkid) {
        this.billId = pkid;
        this.$http.get("basic", "YiXinShipmentApplication/" + pkid).then((resp) => {
          this.application = resp;
        });
        this.getNodeValue();
      },

      downloadAll() {
        if (this.application.accessoryList.length === 0) {
          this.$message.error("没有可下载的附件！");
        }
        for (let item of this.application.accessoryList) {
          this.download(item);
        }
      },
      //下载单个附件
      download(row) {
        let data = {
          name: row.fileName,
          uuid: row.filePath,
        };
        this.$http.exportFile("basic", "file/download", data).then(res => {
          console.log(res);
          let blob = new Blob([res.data], {type: "application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },

      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", `YiXinShipmentApplication/upload/${this.billId}`, formData)
          .then((res) => {
            this.uploadLoading = false;
            console.log(res);
            this.application.accessoryList.push({
              fileName: res.originalName,
              filePath: res.fullPath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },

      doApprove() {
        let updateflag = false;

        let approveVar = "";
        let billParam = [];
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          transferTo: this.params.transferTo,
          billParam: JSON.stringify(billParam),
          approveVar: approveVar,
        };
        console.log("doApprove", this.nodeId);

        this.$emit("loading-status", {loading: true});

        if (this.params.actionType === 0) {
          if (this.nodeId === "DqDingDanApprove" || this.nodeId === "YiXinShipApprove") {
            this.application.status = 2;
            updateflag = true;
            console.log(this.application);
          }
          if (this.nodeId === "YiXinDocumentApprove") {
            updateflag = true;
            console.log(this.application);
          }
        } else if (this.params.actionType === 2) {
          this.application.status = 0;
          updateflag = true;
          console.log(this.application);
        }

        if (updateflag) {
          console.log(this.application);
          this.$http.put("basic", "YiXinShipmentApplication", this.application);
        }
        

        // 审批
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", {loading: false});
            this.$message.success("审批成功");

            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/YiXinApplication",
            });
          })
          .catch(() => {
            this.$emit("loading-status", {loading: false});
          });
      },

      changeDetailShow() {
        this.isShowDetail = !this.isShowDetail;
      },

      changePackShow() {
        this.isShowPack = !this.isShowPack;
      },

      addPack() {
        let obj = {
          volume: "",
          weight: 0,
          qty: 0,
          size: "",
          factoryNos: "",
        };
        this.application.packList.push(obj);
      },

      deletePack(index) {
        this.application.packList.splice(index, 1);
      },

      getNodeValue() {
        let params = {
          "billType": this.billType,
          "billId": this.billId,
          "sequId": this.sequId,
        };
        console.log("getNodeValue");
        this.$http
          .get("basic", "applications/approve", params)
          .then(resp => {
            this.nodeId = resp.nodeId;
            if (this.nodeId === "YiXinDocumentApprove") {
              this.yiXinDocumentApprove = true;
            }
          });
      },

      updateApplication(){
        this.$http.put("basic", "YiXinShipmentApplication", this.application);
      },
    },
  };
</script>
<style lang="scss">
@media (max-width: 1280px) {
  .YiXinApplicationPreview {
    width: 97%;
    overflow-x: scroll;
  }
}

.YiXinApplicationPreview {
  .el-table th {
    background: #d1e6f5;
    height: 34px;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border: 1px solid #dddddd;
    border-bottom: none;
  }

  table.gridtable th {
    text-align: left;
    padding: 8px;
    background-color: #d1e6f5;
  }

  table.gridtable td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
    border-top: none;
    border-right: none;
    min-width: 150px;
  }

  .tableLabel {
    width: 120px;
    text-align: left;
    background-color: #d1e6f5;
  }

  .el-button {
    margin-left: 0 !important;
    margin-right: 5px !important;
  }
}
</style>
